module.exports = __webpack_public_path__ + "img/y_p3_y6.626ef173.png";